import { useOrganization } from "@/contexts/OrganizationContext";

/**
 * @deprecated Use `useCapabilities().isTrialing` instead.
 * This hook is deprecated and will be removed in a future version.
 * Migrate to the unified capabilities system for all feature gating.
 * 
 * Migration example:
 * ```ts
 * // Old:
 * const isTrialAccount = useIsTrialAccount();
 * 
 * // New:
 * const capabilities = useCapabilities();
 * const isTrialing = capabilities.isTrialing;
 * ```
 */
export function useIsTrialAccount() {
  const { currentOrganization } = useOrganization();
  
  if (!currentOrganization) {
    return false;
  }
  
  // Use NEW lifecycle field as source of truth (primary)
  // lifecycle can be: 'trialing', 'active', 'canceled', 'archived'
  if (currentOrganization.lifecycle) {
    return currentOrganization.lifecycle === 'trialing';
  }
  
  // Fallback to legacy fields if lifecycle not set
  const isTrialStatus = currentOrganization.status === 'trial_active' || 
                         currentOrganization.status === 'trial_expired';
  const isTrialPlan = currentOrganization.planType === 'trial';
  
  return isTrialStatus || isTrialPlan;
}

export function useIsFreePlanAccount() {
  const { currentOrganization } = useOrganization();
  
  if (!currentOrganization) {
    return false;
  }
  
  // Check if on free plan
  // Free plan means: planType='free' AND (lifecycle='canceled' OR lifecycle='archived')
  const isFreePlan = currentOrganization.planType === 'free';
  const isCancelledOrArchived = currentOrganization.lifecycle === 'canceled' || 
                                 currentOrganization.lifecycle === 'archived';
  
  return isFreePlan && isCancelledOrArchived;
}
